"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class RcReactTablePageInfo extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "updateShowingText", event => {
      this.setState({
        page: event.detail.page,
        pageSize: event.detail.pageSize,
        isLoading: event.detail.isLoading,
        selected: event.detail.selected
      });
    });
    this.state = {
      page: 0,
      pageSize: 0,
      isLoading: true,
      selected: null
    };
    this.updateShowingText = this.updateShowingText.bind(this);
    const {
      tableIdentifer
    } = props;
    window.document.addEventListener(`rc-react-table-pageinfo-update-${tableIdentifer}`, this.updateShowingText);
  }
  componentDidMount() {}
  componentWillUnmount() {
    const {
      tableIdentifer
    } = this.props;
    window.document.removeEventListener(`rc-react-table-pageinfo-update-${tableIdentifer}`, this.updateShowingText);
  }
  render() {
    const {
      page,
      pageSize,
      isLoading,
      selected
    } = this.state;
    const {
      totalItems
    } = this.props;
    const fromItem = page === 0 ? 1 : page * pageSize + 1;
    let toItem = fromItem + pageSize - 1;
    if (toItem > totalItems) toItem = totalItems;
    return isLoading || totalItems === 0 ? null : `${typeof selected !== 'undefined' && selected !== null ? `Selected ${selected.toLocaleString()} | ` : ''}Showing ${fromItem} - ${toItem.toLocaleString()} of ${totalItems.toLocaleString()}`;
  }
}
exports.default = RcReactTablePageInfo;
RcReactTablePageInfo.propTypes = {
  totalItems: _propTypes.default.number.isRequired,
  tableIdentifer: _propTypes.default.string
};
RcReactTablePageInfo.defaultProps = {
  tableIdentifer: 'default'
};
//# sourceMappingURL=RcReactTablePageInfo.js.map